import { FC, PropsWithChildren, ReactNode } from 'react';
import { Box, Grid } from '@mui/material';

import { MAIN_CONTENT_ID } from '@/components/SkipToMainContentLink';
import { CONTAINER_NAME } from '../../../utils/containerGrid';

interface Props {
  topContent?: ReactNode;
}

export const MainContentV2: FC<PropsWithChildren<Props>> = ({ children, topContent }) => (
  <Box
    id={MAIN_CONTENT_ID}
    component="main"
    sx={{
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      px: { xs: 2, md: 3 },
      py: 2,
      overflow: 'auto',
    }}
  >
    {!!topContent && <Box sx={{ mb: 3 }}>{topContent}</Box>}

    <Grid
      size="grow"
      sx={(theme) => ({
        '&& > *:only-child': {
          height: '100%',
          backgroundColor: theme.palette.background.default,
        },
        containerType: 'inline-size',
        containerName: CONTAINER_NAME,
      })}
    >
      {children}
    </Grid>
  </Box>
);
